// Swiper -----------------------------------------------------------
import Swiper, * as Carousel from 'swiper';
window.Swiper = Swiper;
window.Carousel = Carousel;

let otherBlogCarousel = new Swiper('.other-blog-carousel', {
    speed: 1000,
    slidesPerView: 3,
    spaceBetween: 45,
    loop: true,
    modules: [Carousel.Autoplay, Carousel.Navigation, Carousel.Pagination],
    /* autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    }, */
    navigation: {
        prevEl: '.other-blog-prev',
        nextEl: '.other-blog-next',
    },
    pagination: {
        el: ".other-blog-pagination",
        clickable: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        600: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        601: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1201: {
            slidesPerView: 3,
        },
    },
});

let homepageBlogCarousel = new Swiper('.homepage-blog-carousel', {
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    modules: [Carousel.Autoplay, Carousel.Navigation, Carousel.Pagination, Carousel.Parallax],
    parallax: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    navigation: {
        prevEl: '.homepage-blog-prev',
        nextEl: '.homepage-blog-next',
    },
    pagination: {
        el: ".homepage-blog-pagination",
        clickable: true,
    },
});

let hpOneCarousel = new Swiper('.hp-one-carousel', {
    speed: 1000,
    slidesPerView: 2,
    spaceBetween: 30,
    loop: true,
    modules: [Carousel.Autoplay, Carousel.Navigation, Carousel.Pagination],
    /* autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    }, */
    navigation: {
        prevEl: '.hp-one-prev',
        nextEl: '.hp-one-next',
    },
    pagination: {
        el: ".hp-one-pagination",
        clickable: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        600: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        601: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        1201: {
            slidesPerView: 2,
        },
    },
});

let hpTwoCarousel = new Swiper('.hp-two-carousel', {
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    modules: [Carousel.Autoplay, Carousel.Navigation, Carousel.Pagination, Carousel.Parallax],
    parallax: true,
    /* autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    }, */
    navigation: {
        prevEl: '.hp-two-prev',
        nextEl: '.hp-two-next',
    },
    pagination: {
        el: ".hp-two-pagination",
        clickable: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        600: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        601: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        1201: {
            slidesPerView: 2,
        },
    },
});

let otherProductCarousel = new Swiper('.other-product-carousel', {
    speed: 1000,
    slidesPerView: 3,
    spaceBetween: 45,
    loop: true,
    modules: [Carousel.Autoplay, Carousel.Navigation, Carousel.Pagination],
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    navigation: {
        prevEl: '.other-product-prev',
        nextEl: '.other-product-next',
    },
    pagination: {
        el: ".other-product-pagination",
        clickable: true,
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        600: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        601: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        1201: {
            slidesPerView: 3,
        },
    },
});

if ($('.product-carousel').length) {
    let productCarousel = new Swiper('.product-carousel', {
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 45,
        modules: [Carousel.Autoplay, Carousel.Navigation, Carousel.EffectCreative],
        effect: 'creative',
        creativeEffect: {
            prev: {
                scale: 1.2,
                opacity: 0,
                shadow: true,
            },
            next: {
                scale: 1.2,
                opacity: 0,
                shadow: true,
            },
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            prevEl: '.product-prev',
            nextEl: '.product-next',
        }
    })
    /* COLOR/MODEL SEÇİMİ YAPILINCA SLIDER DEĞİŞİMİ */
    /* let colorSelectLI = $('.product-detail-field .wrapper .image-field .carousel-field .carousel-selector > ul > li .inner-menu > ul > li')
    let techicSelectLI = $('.product-detail-field .wrapper .image-field .carousel-field .carousel-selector > ul > li.technical')
    let productCarouselSlide = $('.product-carousel .swiper-wrapper .swiper-slide')
    let slideID, menuID
    colorSelectLI.click(function () {
        menuID = $(this).attr('data-id')
        $.each(productCarouselSlide, function () {
            slideID = $(this).attr('data-id')
            if (slideID == menuID) {
                productCarousel.slideTo(menuID)
            }
        })
    })
    techicSelectLI.click(function () {
        menuID = $(this).attr('data-id')
        $.each(productCarouselSlide, function () {
            slideID = $(this).attr('data-id')
            if (slideID == menuID) {
                productCarousel.slideTo(menuID)
            }
        })
    }) */
}

if ($('.homepage-product-carousel').length) {
    // HOMEPAGE CAROUSEL FIELD
    let aboutImageGallery = new Swiper('.homepage-product-carousel', {
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 45,
        modules: [Carousel.Navigation, Carousel.Pagination, Carousel.EffectFade],
        effect: 'fade',
        shortSwipes: false,
        navigation: {
            prevEl: '.homepage-product-prev',
            nextEl: '.homepage-product-next',
        },
        pagination: {
            el: ".homepage-product-pagination",
            clickable: true,
        },
    })

    // VARIABLES
    let textContent = $('.homepage-product-field .wrapper .text-field .main-text-content .text-content')
    let aboutSlide = $('.homepage-product-carousel .swiper-slide')
    let colorField = $('.homepage-product-field .wrapper .carousel-field .carousel-controller .color-field')
    let textContentID, hoverTimeOut

    // MAIN TEXT CONTENT - HEIGHT FIX - START
    let mainTextContent = $('.homepage-product-field .wrapper .text-field .main-text-content')
    mainTextContent.css({
        'height': mainTextContent.find('.text-content.active').height()
    })
    if (windowWidth > 1024) {
        colorField.closest('.general-color-field').css({ 'height': $('.homepage-product-field .wrapper .carousel-field .carousel-controller .color-field.active').height() + 40 })
        setTimeout(() => {
            colorField.closest('.general-color-field').css({ 'height': $('.homepage-product-field .wrapper .carousel-field .carousel-controller .color-field.active').height() + 40 })
        }, 450);
    } else {
        colorField.closest('.general-color-field').css({ 'height': $('.homepage-product-field .wrapper .carousel-field .carousel-controller .color-field.active').height() + 20 })
        setTimeout(() => {
            colorField.closest('.general-color-field').css({ 'height': $('.homepage-product-field .wrapper .carousel-field .carousel-controller .color-field.active').height() + 20 })
        }, 450);
    }
    // MAIN TEXT CONTENT - HEIGHT FIX - END

    // SAYFA İLK YÜKLENDİĞİ ZAMAN, İLK DESENE AİT İLK RENGİN SEÇİLİ GELMESİ VE RENKTE BULUNAN RESİM DEĞERİNİN EKRANA YAZILMASI - START
    $.each(aboutSlide, function () {
        if ($(this).hasClass('swiper-slide-active')) {
            // DESEN VARSA - DESEN VE RENK SEÇİMİ
            if ($(this).find('.carousel-controller .texture-field').length) {
                $(this).find('.carousel-controller .texture-field ul li').removeClass('active') // MEVCUT SLIDER DESEN SEÇİMİNİN İPTALİ 
                $(this).find('.carousel-controller .texture-field ul li').first().addClass('active') // MEVCUT SLIDER İLK DESEN SEÇİMİ
                let activeTextureID = $(this).find('.carousel-controller .texture-field ul li').first().attr('data-id')
                let currentTextureColors = $(this).find('.carousel-controller .general-color-field')
                let selectedColorIMG1, selectedColorIMG2, selectedColorIMGField1, selectedColorIMGField2, selectedColorIMGField3
                $.each(currentTextureColors.find('.color-field'), function () {
                    $(this).removeClass('active')
                    $(this).find('ul li').removeClass('active') // RENKLERİN SEÇİMİNİ İPTAL ETME
                    let currentColorsID = $(this).attr('data-id')
                    if (activeTextureID == currentColorsID) {
                        $(this).addClass('active') // İLK RENK ALANINI ACTIVE ETME
                        $(this).find('ul li').first().addClass('active') // İLK RENK ALANININ BİRİNCİ RENGİNİ ACTIVE ETME

                        // GENEL RESİMLERİ, SEÇİLEN DESENİN İLK RENGİ İLE DEĞİŞTİRME
                        selectedColorIMG1 = $(this).find('ul li').first().attr('data-image-one')
                        selectedColorIMG2 = $(this).find('ul li').first().attr('data-image-two')
                        selectedColorIMGField1 = $(this).closest('.image-content').find('.image--one .image--always')
                        selectedColorIMGField3 = $(this).closest('.image-content').find('.image--one .image--mobile')
                        selectedColorIMGField2 = $(this).closest('.image-content').find('.image--two .image-box')

                        if (windowWidth > 768) {
                            // WEB GÖRÜNÜM
                            selectedColorIMGField1.addClass('active');
                            selectedColorIMGField2.addClass('active');
                            clearTimeout(hoverTimeOut);
                            hoverTimeOut = setTimeout(() => {
                                selectedColorIMGField1.find('img').attr('src', selectedColorIMG1);
                                selectedColorIMGField2.find('img').attr('src', selectedColorIMG2);
                                selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG1);
                                selectedColorIMGField2.find('.image-popup').attr('href', selectedColorIMG2);

                                let loadedImage = document.createElement('img');
                                loadedImage.src = selectedColorIMG1

                                selectedColorIMGField1.removeClass('active');
                                selectedColorIMGField2.removeClass('active');
                            }, 450);
                        } else {
                            // MOBİL GÖRÜNÜM
                            selectedColorIMGField1.addClass('active');
                            selectedColorIMGField3.addClass('active');
                            clearTimeout(hoverTimeOut);
                            hoverTimeOut = setTimeout(() => {
                                selectedColorIMGField1.find('img').attr('src', selectedColorIMG2);
                                selectedColorIMGField3.find('img').attr('src', selectedColorIMG1);
                                selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG2);
                                selectedColorIMGField3.find('.image-popup').attr('href', selectedColorIMG1);

                                let loadedImage = document.createElement('img');
                                loadedImage.src = selectedColorIMG1

                                selectedColorIMGField1.removeClass('active');
                                selectedColorIMGField3.removeClass('active');
                            }, 450);
                        }

                        // RENK SEÇİMİ YAPINCA, RESİMLERİN DEĞİŞMESİ - START
                        $(this).find('ul li').click(function () {
                            $(this).closest('ul').find('li').removeClass('active')
                            $(this).addClass('active')

                            selectedColorIMG1 = $(this).attr('data-image-one')
                            selectedColorIMG2 = $(this).attr('data-image-two')
                            selectedColorIMGField1 = $(this).closest('.image-content').find('.image--one .image--always')
                            selectedColorIMGField3 = $(this).closest('.image-content').find('.image--one .image--mobile')
                            selectedColorIMGField2 = $(this).closest('.image-content').find('.image--two .image-box')
                            selectedColorIMGField1.attr('src', selectedColorIMG1) // RESİM DEĞİŞTİRME
                            selectedColorIMGField2.attr('src', selectedColorIMG2) // RESİM DEĞİŞTİRME
                            selectedColorIMGField3.attr('src', selectedColorIMG2) // RESİM DEĞİŞTİRME
                            selectedColorIMGField1.closest('a').attr('href', selectedColorIMG1) // FANCYBOX DEĞİŞTİRME
                            selectedColorIMGField2.closest('a').attr('href', selectedColorIMG2) // FANCYBOX DEĞİŞTİRME
                            selectedColorIMGField3.find('a').attr('href', selectedColorIMG2) // FANCYBOX DEĞİŞTİRME

                            if (windowWidth > 768) {
                                // WEB GÖRÜNÜM
                                selectedColorIMGField1.addClass('active');
                                selectedColorIMGField2.addClass('active');
                                clearTimeout(hoverTimeOut);
                                hoverTimeOut = setTimeout(() => {
                                    selectedColorIMGField1.find('img').attr('src', selectedColorIMG1);
                                    selectedColorIMGField2.find('img').attr('src', selectedColorIMG2);
                                    selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG1);
                                    selectedColorIMGField2.find('.image-popup').attr('href', selectedColorIMG2);

                                    let loadedImage = document.createElement('img');
                                    loadedImage.src = selectedColorIMG1

                                    selectedColorIMGField1.removeClass('active');
                                    selectedColorIMGField2.removeClass('active');
                                }, 450);
                            } else {
                                // MOBİL GÖRÜNÜM
                                selectedColorIMGField1.addClass('active');
                                selectedColorIMGField3.addClass('active');
                                clearTimeout(hoverTimeOut);
                                hoverTimeOut = setTimeout(() => {
                                    selectedColorIMGField1.find('img').attr('src', selectedColorIMG2);
                                    selectedColorIMGField3.find('img').attr('src', selectedColorIMG1);
                                    selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG2);
                                    selectedColorIMGField3.find('.image-popup').attr('href', selectedColorIMG1);

                                    let loadedImage = document.createElement('img');
                                    loadedImage.src = selectedColorIMG1

                                    selectedColorIMGField1.removeClass('active');
                                    selectedColorIMGField3.removeClass('active');
                                }, 450);
                            }
                        })
                        // RENK SEÇİMİ YAPINCA, RESİMLERİN DEĞİŞMESİ - END
                    }
                })
            } else {
                // DESEN YOKSA - SADECE RENK SEÇİMİ İLE DEĞİŞME
                let currentTextureColors = $(this).find('.carousel-controller .general-color-field')
                let selectedColorIMG1, selectedColorIMG2, selectedColorIMGField1, selectedColorIMGField2, selectedColorIMGField3
                $.each(currentTextureColors.find('.color-field'), function () {
                    $(this).removeClass('active')
                    if ($(this).attr('data-id') == 1) {
                        $(this).first().addClass('active')
                        $(this).find('ul li').first().addClass('active')

                        // GENEL RESİMLERİ, SEÇİLEN DESENİN İLK RENGİ İLE DEĞİŞTİRME
                        selectedColorIMG1 = $(this).find('ul li').first().attr('data-image-one')
                        selectedColorIMG2 = $(this).find('ul li').first().attr('data-image-two')
                        selectedColorIMGField1 = $(this).closest('.image-content').find('.image--one .image--always')
                        selectedColorIMGField3 = $(this).closest('.image-content').find('.image--one .image--mobile')
                        selectedColorIMGField2 = $(this).closest('.image-content').find('.image--two .image-box')

                        if (windowWidth > 768) {
                            // WEB GÖRÜNÜM
                            selectedColorIMGField1.addClass('active');
                            selectedColorIMGField2.addClass('active');
                            clearTimeout(hoverTimeOut);
                            hoverTimeOut = setTimeout(() => {
                                selectedColorIMGField1.find('img').attr('src', selectedColorIMG1);
                                selectedColorIMGField2.find('img').attr('src', selectedColorIMG2);
                                selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG1);
                                selectedColorIMGField2.find('.image-popup').attr('href', selectedColorIMG2);

                                let loadedImage = document.createElement('img');
                                loadedImage.src = selectedColorIMG1

                                selectedColorIMGField1.removeClass('active');
                                selectedColorIMGField2.removeClass('active');
                            }, 450);
                        } else {
                            // MOBİL GÖRÜNÜM
                            selectedColorIMGField1.addClass('active');
                            selectedColorIMGField3.addClass('active');
                            clearTimeout(hoverTimeOut);
                            hoverTimeOut = setTimeout(() => {
                                selectedColorIMGField1.find('img').attr('src', selectedColorIMG2);
                                selectedColorIMGField3.find('img').attr('src', selectedColorIMG1);
                                selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG2);
                                selectedColorIMGField3.find('.image-popup').attr('href', selectedColorIMG1);

                                let loadedImage = document.createElement('img');
                                loadedImage.src = selectedColorIMG1

                                selectedColorIMGField1.removeClass('active');
                                selectedColorIMGField3.removeClass('active');
                            }, 450);
                        }

                        // RENK SEÇİMİ YAPINCA, RESİMLERİN DEĞİŞMESİ - START
                        $(this).find('ul li').click(function () {
                            $(this).closest('ul').find('li').removeClass('active')
                            $(this).addClass('active')

                            selectedColorIMG1 = $(this).attr('data-image-one')
                            selectedColorIMG2 = $(this).attr('data-image-two')
                            selectedColorIMGField1 = $(this).closest('.image-content').find('.image--one .image--always')
                            selectedColorIMGField3 = $(this).closest('.image-content').find('.image--one .image--mobile')
                            selectedColorIMGField2 = $(this).closest('.image-content').find('.image--two .image-box')
                            selectedColorIMGField1.attr('src', selectedColorIMG1) // RESİM DEĞİŞTİRME
                            selectedColorIMGField2.attr('src', selectedColorIMG2) // RESİM DEĞİŞTİRME
                            selectedColorIMGField3.attr('src', selectedColorIMG2) // RESİM DEĞİŞTİRME
                            selectedColorIMGField1.closest('a').attr('href', selectedColorIMG1) // FANCYBOX DEĞİŞTİRME
                            selectedColorIMGField2.closest('a').attr('href', selectedColorIMG2) // FANCYBOX DEĞİŞTİRME
                            selectedColorIMGField3.find('a').attr('href', selectedColorIMG2) // FANCYBOX DEĞİŞTİRME

                            if (windowWidth > 768) {
                                // WEB GÖRÜNÜM
                                selectedColorIMGField1.addClass('active');
                                selectedColorIMGField2.addClass('active');
                                clearTimeout(hoverTimeOut);
                                hoverTimeOut = setTimeout(() => {
                                    selectedColorIMGField1.find('img').attr('src', selectedColorIMG1);
                                    selectedColorIMGField2.find('img').attr('src', selectedColorIMG2);
                                    selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG1);
                                    selectedColorIMGField2.find('.image-popup').attr('href', selectedColorIMG2);

                                    let loadedImage = document.createElement('img');
                                    loadedImage.src = selectedColorIMG1

                                    selectedColorIMGField1.removeClass('active');
                                    selectedColorIMGField2.removeClass('active');
                                }, 450);
                            } else {
                                // MOBİL GÖRÜNÜM
                                selectedColorIMGField1.addClass('active');
                                selectedColorIMGField3.addClass('active');
                                clearTimeout(hoverTimeOut);
                                hoverTimeOut = setTimeout(() => {
                                    selectedColorIMGField1.find('img').attr('src', selectedColorIMG2);
                                    selectedColorIMGField3.find('img').attr('src', selectedColorIMG1);
                                    selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG2);
                                    selectedColorIMGField3.find('.image-popup').attr('href', selectedColorIMG1);

                                    let loadedImage = document.createElement('img');
                                    loadedImage.src = selectedColorIMG1

                                    selectedColorIMGField1.removeClass('active');
                                    selectedColorIMGField3.removeClass('active');
                                }, 450);
                            }
                        })
                        // RENK SEÇİMİ YAPINCA, RESİMLERİN DEĞİŞMESİ - END
                    }
                })
            }
        }
    })
    // SAYFA İLK YÜKLENDİĞİ ZAMAN, İLK DESENE AİT İLK RENGİN SEÇİLİ GELMESİ VE RENKTE BULUNAN RESİM DEĞERİNİN EKRANA YAZILMASI - END

    // TEXTURE TIKLAMA - START
    let textureField = $('.homepage-product-field .wrapper .carousel-field .carousel-controller .texture-field')
    textureField.find('li').click(function () {
        let textureID = $(this).attr('data-id')
        textureField.find('li').removeClass('active')
        $(this).addClass('active')
        // TEXTURE DEĞİŞİNCE RENK DEĞİŞİMİ - START
        let currentTextureColors = $(this).closest('.carousel-controller').find('.general-color-field')
        let selectedColorIMG1, selectedColorIMG2, selectedColorIMGField1, selectedColorIMGField2, selectedColorIMGField3
        $.each(currentTextureColors.find('.color-field'), function () {
            $(this).removeClass('active') // İLK RENK ALANINI ACTIVE ETME
            $(this).find('ul li').removeClass('active') // RENKLERİN SEÇİMİNİ İPTAL ETME
            let currentColorsID = $(this).attr('data-id')
            if (textureID == currentColorsID) {
                $(this).addClass('active')
                $(this).find('ul li').first().addClass('active') // İLK RENK ALANININ BİRİNCİ RENGİNİ ACTIVE ETME

                // GENEL RESİMLERİ, SEÇİLEN DESENİN İLK RENGİ İLE DEĞİŞTİRME
                selectedColorIMG1 = $(this).find('ul li').first().attr('data-image-one')
                selectedColorIMG2 = $(this).find('ul li').first().attr('data-image-two')
                selectedColorIMGField1 = $(this).closest('.image-content').find('.image--one .image--always')
                selectedColorIMGField3 = $(this).closest('.image-content').find('.image--one .image--mobile')
                selectedColorIMGField2 = $(this).closest('.image-content').find('.image--two .image-box')

                if (windowWidth > 768) {
                    // WEB GÖRÜNÜM
                    selectedColorIMGField1.addClass('active');
                    selectedColorIMGField2.addClass('active');
                    clearTimeout(hoverTimeOut);
                    hoverTimeOut = setTimeout(() => {
                        selectedColorIMGField1.find('img').attr('src', selectedColorIMG1);
                        selectedColorIMGField2.find('img').attr('src', selectedColorIMG2);
                        selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG1);
                        selectedColorIMGField2.find('.image-popup').attr('href', selectedColorIMG2);

                        let loadedImage = document.createElement('img');
                        loadedImage.src = selectedColorIMG1

                        selectedColorIMGField1.removeClass('active');
                        selectedColorIMGField2.removeClass('active');
                    }, 450);
                } else {
                    // MOBİL GÖRÜNÜM
                    selectedColorIMGField1.addClass('active');
                    selectedColorIMGField3.addClass('active');
                    clearTimeout(hoverTimeOut);
                    hoverTimeOut = setTimeout(() => {
                        selectedColorIMGField1.find('img').attr('src', selectedColorIMG2);
                        selectedColorIMGField3.find('img').attr('src', selectedColorIMG1);
                        selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG2);
                        selectedColorIMGField3.find('.image-popup').attr('href', selectedColorIMG1);

                        let loadedImage = document.createElement('img');
                        loadedImage.src = selectedColorIMG1

                        selectedColorIMGField1.removeClass('active');
                        selectedColorIMGField3.removeClass('active');
                    }, 450);
                }

                // RENK SEÇİMİ YAPINCA, RESİMLERİN DEĞİŞMESİ - START
                /* bu yapı, ilk açılışada koyulacak, slidera da koyulacak */
                $(this).find('ul li').click(function () {
                    $(this).closest('ul').find('li').removeClass('active')
                    $(this).addClass('active')

                    selectedColorIMG1 = $(this).attr('data-image-one')
                    selectedColorIMG2 = $(this).attr('data-image-two')
                    selectedColorIMGField1 = $(this).closest('.image-content').find('.image--one .image--always')
                    selectedColorIMGField3 = $(this).closest('.image-content').find('.image--one .image--mobile')
                    selectedColorIMGField2 = $(this).closest('.image-content').find('.image--two .image-box')

                    if (windowWidth > 768) {
                        // WEB GÖRÜNÜM
                        selectedColorIMGField1.addClass('active');
                        selectedColorIMGField2.addClass('active');
                        clearTimeout(hoverTimeOut);
                        hoverTimeOut = setTimeout(() => {
                            selectedColorIMGField1.find('img').attr('src', selectedColorIMG1);
                            selectedColorIMGField2.find('img').attr('src', selectedColorIMG2);
                            selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG1);
                            selectedColorIMGField2.find('.image-popup').attr('href', selectedColorIMG2);

                            let loadedImage = document.createElement('img');
                            loadedImage.src = selectedColorIMG1

                            selectedColorIMGField1.removeClass('active');
                            selectedColorIMGField2.removeClass('active');
                        }, 450);
                    } else {
                        // MOBİL GÖRÜNÜM
                        selectedColorIMGField1.addClass('active');
                        selectedColorIMGField3.addClass('active');
                        clearTimeout(hoverTimeOut);
                        hoverTimeOut = setTimeout(() => {
                            selectedColorIMGField1.find('img').attr('src', selectedColorIMG2);
                            selectedColorIMGField3.find('img').attr('src', selectedColorIMG1);
                            selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG2);
                            selectedColorIMGField3.find('.image-popup').attr('href', selectedColorIMG1);

                            let loadedImage = document.createElement('img');
                            loadedImage.src = selectedColorIMG1

                            selectedColorIMGField1.removeClass('active');
                            selectedColorIMGField3.removeClass('active');
                        }, 450);
                    }
                })
                // RENK SEÇİMİ YAPINCA, RESİMLERİN DEĞİŞMESİ - END
            }
        })
        // TEXTURE DEĞİŞİNCE RENK DEĞİŞİMİ - END
    })
    // TEXTURE TIKLAMA - END

    // SLIDER CHANGE - START
    let aboutSlideID
    aboutImageGallery.on('slideChange', function () {
        // SLIDE DEĞİŞİNCE, İLK DESENİN SEÇİLİ GELMESİ - START
        $.each(aboutSlide, function () {
            $(this).removeClass('active')
            aboutSlideID = $(this).attr('data-id')
            if (aboutSlideID == aboutImageGallery.realIndex + 1) {
                // DESEN VARSA - DESEN VE RENK SEÇİMİ
                if ($(this).find('.texture-field').length) {
                    let textureID = $(this).find('.texture-field ul li').first().attr('data-id')
                    $(this).find('.texture-field ul li').first().addClass('active')
                    // SLIDE DEĞİŞİNCE, İLK DESENE AİT, İLK RENGİN SEÇİLİ GELMESİ - START
                    let currentTextureColors = $(this).find('.carousel-controller').find('.general-color-field')
                    let selectedColorIMG1, selectedColorIMG2, selectedColorIMGField1, selectedColorIMGField2, selectedColorIMGField3
                    $.each(currentTextureColors.find('.color-field'), function () {
                        $(this).removeClass('active') // İLK RENK ALANINI ACTIVE ETME
                        $(this).find('ul li').removeClass('active') // RENKLERİN SEÇİMİNİ İPTAL ETME
                        let currentColorsID = $(this).attr('data-id')
                        if (textureID == currentColorsID) {
                            $(this).addClass('active')
                            $(this).find('ul li').first().addClass('active') // İLK RENK ALANININ BİRİNCİ RENGİNİ ACTIVE ETME

                            // GENEL RESİMLERİ, SEÇİLEN DESENİN İLK RENGİ İLE DEĞİŞTİRME
                            selectedColorIMG1 = $(this).find('ul li').first().attr('data-image-one')
                            selectedColorIMG2 = $(this).find('ul li').first().attr('data-image-two')
                            selectedColorIMGField1 = $(this).closest('.image-content').find('.image--one .image--always')
                            selectedColorIMGField3 = $(this).closest('.image-content').find('.image--one .image--mobile')
                            selectedColorIMGField2 = $(this).closest('.image-content').find('.image--two .image-box')

                            if (windowWidth > 768) {
                                // WEB GÖRÜNÜM
                                selectedColorIMGField1.addClass('active');
                                selectedColorIMGField2.addClass('active');
                                clearTimeout(hoverTimeOut);
                                hoverTimeOut = setTimeout(() => {
                                    selectedColorIMGField1.find('img').attr('src', selectedColorIMG1);
                                    selectedColorIMGField2.find('img').attr('src', selectedColorIMG2);
                                    selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG1);
                                    selectedColorIMGField2.find('.image-popup').attr('href', selectedColorIMG2);

                                    let loadedImage = document.createElement('img');
                                    loadedImage.src = selectedColorIMG1

                                    selectedColorIMGField1.removeClass('active');
                                    selectedColorIMGField2.removeClass('active');
                                }, 450);
                            } else {
                                // MOBİL GÖRÜNÜM
                                selectedColorIMGField1.addClass('active');
                                selectedColorIMGField3.addClass('active');
                                clearTimeout(hoverTimeOut);
                                hoverTimeOut = setTimeout(() => {
                                    selectedColorIMGField1.find('img').attr('src', selectedColorIMG2);
                                    selectedColorIMGField3.find('img').attr('src', selectedColorIMG1);
                                    selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG2);
                                    selectedColorIMGField3.find('.image-popup').attr('href', selectedColorIMG1);

                                    let loadedImage = document.createElement('img');
                                    loadedImage.src = selectedColorIMG1

                                    selectedColorIMGField1.removeClass('active');
                                    selectedColorIMGField3.removeClass('active');
                                }, 450);
                            }

                            // RENK SEÇİMİ YAPINCA, RESİMLERİN DEĞİŞMESİ - START
                            $(this).find('ul li').click(function () {
                                $(this).closest('ul').find('li').removeClass('active')
                                $(this).addClass('active')

                                selectedColorIMG1 = $(this).attr('data-image-one')
                                selectedColorIMG2 = $(this).attr('data-image-two')
                                selectedColorIMGField1 = $(this).closest('.image-content').find('.image--one .image--always')
                                selectedColorIMGField3 = $(this).closest('.image-content').find('.image--one .image--mobile')
                                selectedColorIMGField2 = $(this).closest('.image-content').find('.image--two .image-box')

                                if (windowWidth > 768) {
                                    // WEB GÖRÜNÜM
                                    selectedColorIMGField1.addClass('active');
                                    selectedColorIMGField2.addClass('active');
                                    clearTimeout(hoverTimeOut);
                                    hoverTimeOut = setTimeout(() => {
                                        selectedColorIMGField1.find('img').attr('src', selectedColorIMG1);
                                        selectedColorIMGField2.find('img').attr('src', selectedColorIMG2);
                                        selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG1);
                                        selectedColorIMGField2.find('.image-popup').attr('href', selectedColorIMG2);

                                        let loadedImage = document.createElement('img');
                                        loadedImage.src = selectedColorIMG1

                                        selectedColorIMGField1.removeClass('active');
                                        selectedColorIMGField2.removeClass('active');
                                    }, 450);
                                } else {
                                    // MOBİL GÖRÜNÜM
                                    selectedColorIMGField1.addClass('active');
                                    selectedColorIMGField3.addClass('active');
                                    clearTimeout(hoverTimeOut);
                                    hoverTimeOut = setTimeout(() => {
                                        selectedColorIMGField1.find('img').attr('src', selectedColorIMG2);
                                        selectedColorIMGField3.find('img').attr('src', selectedColorIMG1);
                                        selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG2);
                                        selectedColorIMGField3.find('.image-popup').attr('href', selectedColorIMG1);

                                        let loadedImage = document.createElement('img');
                                        loadedImage.src = selectedColorIMG1

                                        selectedColorIMGField1.removeClass('active');
                                        selectedColorIMGField3.removeClass('active');
                                    }, 450);
                                }
                            })
                            // RENK SEÇİMİ YAPINCA, RESİMLERİN DEĞİŞMESİ - END
                        }
                    })
                    // SLIDE DEĞİŞİNCE, İLK DESENE AİT, İLK RENGİN SEÇİLİ GELMESİ - END
                } else {
                    // DESEN YOKSA - SADECE RENK SEÇİMİ İLE DEĞİŞME
                    let currentTextureColors = $(this).find('.carousel-controller .general-color-field')
                    let selectedColorIMG1, selectedColorIMG2, selectedColorIMGField1, selectedColorIMGField2, selectedColorIMGField3
                    $.each(currentTextureColors.find('.color-field'), function () {
                        $(this).removeClass('active')
                        if ($(this).attr('data-id') == 1) {
                            $(this).first().addClass('active')
                            $(this).find('ul li').first().addClass('active')

                            // GENEL RESİMLERİ, SEÇİLEN DESENİN İLK RENGİ İLE DEĞİŞTİRME
                            selectedColorIMG1 = $(this).find('ul li').first().attr('data-image-one')
                            selectedColorIMG2 = $(this).find('ul li').first().attr('data-image-two')
                            selectedColorIMGField1 = $(this).closest('.image-content').find('.image--one .image--always')
                            selectedColorIMGField3 = $(this).closest('.image-content').find('.image--one .image--mobile')
                            selectedColorIMGField2 = $(this).closest('.image-content').find('.image--two .image-box')

                            if (windowWidth > 768) {
                                // WEB GÖRÜNÜM
                                selectedColorIMGField1.addClass('active');
                                selectedColorIMGField2.addClass('active');
                                clearTimeout(hoverTimeOut);
                                hoverTimeOut = setTimeout(() => {
                                    selectedColorIMGField1.find('img').attr('src', selectedColorIMG1);
                                    selectedColorIMGField2.find('img').attr('src', selectedColorIMG2);
                                    selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG1);
                                    selectedColorIMGField2.find('.image-popup').attr('href', selectedColorIMG2);

                                    let loadedImage = document.createElement('img');
                                    loadedImage.src = selectedColorIMG1

                                    selectedColorIMGField1.removeClass('active');
                                    selectedColorIMGField2.removeClass('active');
                                }, 450);
                            } else {
                                // MOBİL GÖRÜNÜM
                                selectedColorIMGField1.addClass('active');
                                selectedColorIMGField3.addClass('active');
                                clearTimeout(hoverTimeOut);
                                hoverTimeOut = setTimeout(() => {
                                    selectedColorIMGField1.find('img').attr('src', selectedColorIMG2);
                                    selectedColorIMGField3.find('img').attr('src', selectedColorIMG1);
                                    selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG2);
                                    selectedColorIMGField3.find('.image-popup').attr('href', selectedColorIMG1);

                                    let loadedImage = document.createElement('img');
                                    loadedImage.src = selectedColorIMG1

                                    selectedColorIMGField1.removeClass('active');
                                    selectedColorIMGField3.removeClass('active');
                                }, 450);
                            }

                            // RENK SEÇİMİ YAPINCA, RESİMLERİN DEĞİŞMESİ - START
                            $(this).find('ul li').click(function () {
                                $(this).closest('ul').find('li').removeClass('active')
                                $(this).addClass('active')

                                selectedColorIMG1 = $(this).attr('data-image-one')
                                selectedColorIMG2 = $(this).attr('data-image-two')
                                selectedColorIMGField1 = $(this).closest('.image-content').find('.image--one .image--always')
                                selectedColorIMGField3 = $(this).closest('.image-content').find('.image--one .image--mobile')
                                selectedColorIMGField2 = $(this).closest('.image-content').find('.image--two .image-box')
                                selectedColorIMGField1.attr('src', selectedColorIMG1) // RESİM DEĞİŞTİRME
                                selectedColorIMGField2.attr('src', selectedColorIMG2) // RESİM DEĞİŞTİRME
                                selectedColorIMGField3.attr('src', selectedColorIMG2) // RESİM DEĞİŞTİRME
                                selectedColorIMGField1.closest('a').attr('href', selectedColorIMG1) // FANCYBOX DEĞİŞTİRME
                                selectedColorIMGField2.closest('a').attr('href', selectedColorIMG2) // FANCYBOX DEĞİŞTİRME
                                selectedColorIMGField3.find('a').attr('href', selectedColorIMG2) // FANCYBOX DEĞİŞTİRME

                                if (windowWidth > 768) {
                                    // WEB GÖRÜNÜM
                                    selectedColorIMGField1.addClass('active');
                                    selectedColorIMGField2.addClass('active');
                                    clearTimeout(hoverTimeOut);
                                    hoverTimeOut = setTimeout(() => {
                                        selectedColorIMGField1.find('img').attr('src', selectedColorIMG1);
                                        selectedColorIMGField2.find('img').attr('src', selectedColorIMG2);
                                        selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG1);
                                        selectedColorIMGField2.find('.image-popup').attr('href', selectedColorIMG2);

                                        let loadedImage = document.createElement('img');
                                        loadedImage.src = selectedColorIMG1

                                        selectedColorIMGField1.removeClass('active');
                                        selectedColorIMGField2.removeClass('active');
                                    }, 450);
                                } else {
                                    // MOBİL GÖRÜNÜM
                                    selectedColorIMGField1.addClass('active');
                                    selectedColorIMGField3.addClass('active');
                                    clearTimeout(hoverTimeOut);
                                    hoverTimeOut = setTimeout(() => {
                                        selectedColorIMGField1.find('img').attr('src', selectedColorIMG2);
                                        selectedColorIMGField3.find('img').attr('src', selectedColorIMG1);
                                        selectedColorIMGField1.find('.image-popup').attr('href', selectedColorIMG2);
                                        selectedColorIMGField3.find('.image-popup').attr('href', selectedColorIMG1);

                                        let loadedImage = document.createElement('img');
                                        loadedImage.src = selectedColorIMG1

                                        selectedColorIMGField1.removeClass('active');
                                        selectedColorIMGField3.removeClass('active');
                                    }, 450);
                                }
                            })
                            // RENK SEÇİMİ YAPINCA, RESİMLERİN DEĞİŞMESİ - END
                        }
                    })
                }
            }
        })
        // SLIDE DEĞİŞİNCE, İLK DESENİN SEÇİLİ GELMESİ - END

        // SLIDE DEĞİŞİNCE, YAZI ALANININ DEĞİŞMESİ - START
        $.each(textContent, function () {
            $(this).removeClass('active')
            textContentID = $(this).attr('data-id')
            if (textContentID == aboutImageGallery.realIndex) {
                $(this).addClass('active')
                mainTextContent.css({
                    'height': mainTextContent.find('.text-content.active').height()
                })
            }
        })
        // SLIDE DEĞİŞİNCE, YAZI ALANININ DEĞİŞMESİ - END
    })
    // SLIDER CHANGE - END
}

if ($('.homepage-carousel-field').length) {
    let homepageCarousel = new Swiper('.homepage-carousel', {
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 45,
        // loop: true,
        modules: [Carousel.Autoplay, Carousel.Pagination, Carousel.Navigation, Carousel.EffectCreative],
        autoplay: {
            disableOnInteraction: false,
        },
        navigation: {
            prevEl: '.homepage--prev',
            nextEl: '.homepage--next',
        },
        pagination: {
            el: ".homepage-pagination",
            clickable: true,
        },
        effect: 'creative',
        creativeEffect: {
            prev: {
                scale: 1.2,
                opacity: 0,
                shadow: true,
            },
            next: {
                scale: 1.2,
                opacity: 0,
                shadow: true,
            },
        },
    })

    let hsCurrent = $('.homepage-carousel-field .carousel-count .current')
    let hsTotal = $('.homepage-carousel-field .carousel-count .total')
    let sliderTotal = $('.homepage-carousel .swiper-slide:not(.swiper-slide-duplicate)').length;
    hsCurrent.text("0" + (homepageCarousel.realIndex + 1))
    hsTotal.text("0" + sliderTotal)
    hsTotal.text("0" + sliderTotal)

    let colorField = $('.homepage-carousel-field .carousel-line #color-field')
    let carouselLI = $('.homepage-carousel-field .wrapper .carousel-field .carousel-images ul li')
    let carouselLIID

    let homepageSlideItem = document.querySelectorAll('.homepage-carousel .swiper-slide');
    let carouselLine = document.querySelector('.homepage-carousel-field .carousel-line');
    let carouselLineFillable = carouselLine.querySelector('#color-field');

    // carouselLineFillable.classList.add('active');

    // FIRST ITEM
    homepageSlideItem.forEach(function (item, index) {
        // FIRST ITEM
        if (index == homepageCarousel.realIndex) {
            let autoplayDuration = parseFloat(item.getAttribute('data-swiper-autoplay'));
            autoplayDuration = autoplayDuration / 1000;

            // GSAP
            gsap.to(carouselLineFillable, {
                strokeDashoffset: 0,
                duration: autoplayDuration,
                ease: "linear",
            });

        }
    });

    homepageCarousel.on('slideChange', function () {
        hsCurrent.text("0" + (homepageCarousel.realIndex + 1));

        $.each(carouselLI, function () {
            $(this).removeClass('active');
            carouselLIID = $(this).attr('data-id');
            if (carouselLIID == homepageCarousel.activeIndex) {
                $(this).addClass('active');
            }
        });

        homepageSlideItem.forEach(function (item, index) {
            // VİDEOLARI BAŞTAN BAŞLATMA
            if (item.querySelector('.height-dynamic-viewport-offset-header video')) {
                item.querySelector('.height-dynamic-viewport-offset-header video').currentTime = 0;
            }
        });
        gsap.set(carouselLineFillable, {
            strokeDashoffset: 1133,
            ease: "linear",
        });
        homepageSlideItem.forEach(function (item, index) {
            if (index == homepageCarousel.activeIndex) {
                let autoplayDuration = parseFloat(item.getAttribute('data-swiper-autoplay'));
                let autoplayDurationSecond = autoplayDuration / 1000; // Saniye

                // GSAP
                gsap.set(carouselLineFillable, {
                    strokeDashoffset: 1133,
                    ease: "linear",
                    overwrite: true,
                });
                gsap.to(carouselLineFillable, {
                    strokeDashoffset: 0,
                    duration: autoplayDurationSecond + 1,
                    ease: "linear",
                });
            }
        });
    });

    carouselLI.click(function () {
        $(this).removeClass('active');
        carouselLIID = $(this).attr('data-id');

        gsap.set(carouselLineFillable, {
            strokeDashoffset: 1133,
            ease: "linear",
            overwrite: true,
        });
        
        homepageCarousel.slideTo(carouselLIID);

        homepageSlideItem.forEach(function (item, index) {
            // VİDEOLARI BAŞTAN BAŞLATMA
            if (item.querySelector('.height-dynamic-viewport-offset-header video')) {
                item.querySelector('.height-dynamic-viewport-offset-header video').currentTime = 0;
            }
        });
    })

    // WEB - MOBIL IMAGE CHANGE
    let homepageOrderSwiperSlide = $(".homepage-carousel-field .wrapper .carousel-field .homepage-carousel .swiper-wrapper .swiper-slide")
    let mobileImg
    if ($(window).width() < 769) {
        $.each(homepageOrderSwiperSlide, function () {
            mobileImg = $(this).attr("data-mobil-image")
            if ($(this).hasClass('swiper-slide')) {
                $(this).find("img").attr("src", mobileImg)
            }
        })
    } else {
        $.each(homepageOrderSwiperSlide, function () {
            mobileImg = $(this).attr("data-web-image")
            if ($(this).hasClass('swiper-slide')) {
                $(this).find("img").attr("src", mobileImg)
            }
        })
    }
}

if ($('.homepage-order-carousel').length) {
    let homepageOrderCarousel = new Swiper('.homepage-order-carousel', {
        speed: 1000,
        slidesPerView: 1,
        spaceBetween: 45,
        modules: [Carousel.Autoplay, Carousel.EffectCreative],
        /* autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        }, */
        effect: 'creative',
        creativeEffect: {
            prev: {
                scale: 1.2,
                opacity: 0,
                shadow: true,
            },
            next: {
                scale: 1.2,
                opacity: 0,
                shadow: true,
            },
        },
    })

    let carouselLI = $('.homepage-order-field .wrapper .carousel-field .carousel-pagination-field .content ul li')
    let carouselLIID
    homepageOrderCarousel.on('slideChange', function () {
        $.each(carouselLI, function () {
            $(this).removeClass('active')
            carouselLIID = $(this).attr('data-id')
            if (carouselLIID == homepageOrderCarousel.activeIndex) {
                $(this).addClass('active')
            }
        })
    })

    carouselLI.click(function () {
        $(this).removeClass('active')
        carouselLIID = $(this).attr('data-id')
        homepageOrderCarousel.slideTo(carouselLIID)
    })

    // WEB - MOBIL IMAGE CHANGE
    let homepageOrderSwiperSlide = $(".homepage-order-field .wrapper .carousel-field .homepage-order-carousel .swiper-wrapper .swiper-slide")
    let mobileImg
    if ($(window).width() < 769) {
        $.each(homepageOrderSwiperSlide, function () {
            mobileImg = $(this).attr("data-mobil-image")
            if ($(this).hasClass('swiper-slide')) {
                $(this).find(".image-content .main-image img").attr("src", mobileImg)
            }
        })
    } else {
        $.each(homepageOrderSwiperSlide, function () {
            mobileImg = $(this).attr("data-web-image")
            if ($(this).hasClass('swiper-slide')) {
                $(this).find(".image-content .main-image img").attr("src", mobileImg)
            }
        })
    }
}